"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORMATS = void 0;
exports.FORMATS = {
    SHORT_DATE: 'YYYY-MM-DD',
    SLASH_DATE: 'M/D/YYYY'
};
//# sourceMappingURL=FORMATS.js.map